import { initialState } from './state'
export default {
  toggleSignupModal,
  setToken,
  updateSignupForm,
  updateLoginForm,
  updateForgotPasswordForm,
  clearForgotPasswordForm,
  updateChangePasswordForm,
  updateUserChangePasswordForm,
  clearChangePasswordForm,
  resetState
}

function toggleSignupModal (state) {
  state.signupModal = !state.signupModal
}

function setToken (state, payload) {
  state.token = payload
}

function updateSignupForm (state, payload) {
  const { field, value } = payload
  Object.assign(state.signupForm, {
    [field]: value
  })
}

function updateLoginForm (state, payload) {
  const { field, value } = payload
  Object.assign(state.loginForm, {
    [field]: value
  })
}

function updateForgotPasswordForm (state, payload) {
  const { field, value } = payload
  Object.assign(state.forgotPasswordForm, {
    [field]: value
  })
}

function updateChangePasswordForm (state, payload) {
  const { field, value } = payload
  Object.assign(state.changePasswordForm, {
    [field]: value
  })
}

function updateUserChangePasswordForm (state, { userID }) {
  state.changePasswordForm['userID'] = userID
}

function clearChangePasswordForm (state) {
  _.each(state.changePasswordForm, (value, key) => {
    state.changePasswordForm[key] = ''
  })
}

function clearForgotPasswordForm (state) {
  state.forgotPasswordForm = { ...initialState.forgotPasswordForm }
}

function resetState (state) {
  // _.each(state, (value, key) => {
  //     state[key] = initialState[key]
  // })
  state = { ...initialState }
}